import React, {useContext, useMemo} from 'react';
import SelectMaquinaProposta from '../../../Selects/SelectMaquinaProposta';
import SelectComponent from '../../../Selects/SelectComponent';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import BallotRoundedIcon from '@mui/icons-material/BallotRounded';
import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';
import Acessorios from './Acessorios';
import Atributos from './Atributos';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import AcessoriosExtra from './AcessoriosExtra';
import AcessoriosModal from './AcessoriosModal';
import AtributosModal from './AtributosModal';
import AcessoriosExtraModal from './AcessoriosExtraModal';
import {Context} from '../../../../Helpers/Auth';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import {useEffect} from 'react';
import {getCatalogo, getExtras} from '../../../../pages/requests';
import ReferenciaModal from './ReferenciaModal';
import axios from 'axios';

// import { Container } from './styles';

function Linha({
    linhaP,
    handleChildChange = () => {},
    adicionarNovaLinha,
    totalLinhas,
    linha,
    key,
    eliminarLinha,
    editarProposta,
    validacaoEquipamento,
    setValidacaoEquipamento,
    ivas,
    setValidacaoIVA,
    validacaoIVA,
    aluguer,
}) {
    const [artigos, setArtigos] = useState([]);
    const [artigosExtras, setArtigosExtras] = useState([]);
    const [referenciaArtigos, setReferenciaArtigos] = useState([]);
    const {t} = useTranslation();
    const [aberturaLinhaAtributos, setAberturaLinhaAtributos] = useState(false);
    const [aberturaLinhaAcessorios, setAberturaLinhaAcessorios] = useState(false);
    const [aberturaLinhaAcessoriosExtra, setAberturaLinhaAcessoriosExtra] = useState(false);
    const [openAcessoriosModal, setOpenAcessoriosModal] = useState(false);
    const [openAcessoriosExtraModal, setOpenAcessoriosExtraModal] = useState(false);
    const [openAtributosModal, setOpenAtributosModal] = useState(false);
    const [openReferenciaModal, setOpenReferenciaModal] = useState(false);

    const [searchReferencia, setSearchReferencia] = useState('');

    var today = new Date();

    const {acessos, utilizador, rep} = useContext(Context);

    const [controllerAbort, setControllerAbort] = useState();

    function Getartigos(search) {
        if (search.length >= 3) {
            if (controllerAbort) {
                controllerAbort.abort();
            }
            let controlerA = new AbortController();
            setControllerAbort(controlerA);

            getCatalogo(0, 9999, 'POR', controlerA.signal, search)
                .then(res => {
                    if (res.data.success) {
                        setArtigos(res.data.produtos);
                    }
                })
                .catch(console.log);
        } else {
            setArtigos([]);
        }
    }

    const [searchExtra, setSearchExtra] = useState('');
    useEffect(() => {
        let controller = new AbortController();
        const signal = controller.signal;
        getExtras(0, 20, 'POR', signal, searchExtra)
            .then(res => {
                if (res.data.success) {
                    setArtigosExtras(res.data.produtos);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            });
        return () => {
            controller.abort();
        };
    }, [searchExtra]);

    useEffect(() => {
        let controller = new AbortController();
        const signal = controller.signal;
        getCatalogo(0, 20, 'POR', signal, searchReferencia)
            .then(res => {
                if (res.data.success) {
                    setReferenciaArtigos(res.data.produtos);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            });
        return () => {
            controller.abort();
        };
    }, [searchReferencia]);

    function calculoTotalLinha() {
        var total = Number(linhaP?.preco) * Number(linhaP?.quantidade);
        return Math.round((total - (total * linhaP?.desconto) / 100) * 100) / 100;
    }
    function calculoTotalLinhaCExtra() {
        var total = Number(linhaP?.preco) * Number(linhaP?.quantidade);
        total = total - (total * linhaP?.desconto) / 100;

        var totalEx = linhaP.acessoriosExtra
            .map(a => {
                var t = Number(a.preco) * Number(a.quantidade);
                t = t - (t * a.desconto) / 100;
                return Math.round(t * 100) / 100;
            })
            .reduce((a1, a2) => a1 + a2, 0);

        return Math.round((total + totalEx) * 100) / 100;
    }

    function isEmpty() {
        if ((linhaP.referencia == '' || linhaP.referencia == undefined) && (linhaP.nome == '' || linhaP.nome == undefined)) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <>
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 ">
                <td className="text-right w-20 ">
                    {/* Botão de atributos */}
                    <button
                        disabled={isEmpty()}
                        title={t('atributos')}
                        type="button"
                        onClick={() => {
                            if (editarProposta) {
                                setOpenAtributosModal(!openAtributosModal);
                            }
                        }}
                        className={`relative ml-2  inline-flex items-center font-bold p-1 text-xs  text-center cursor-pointer rounded-[5px] bg-blue-200 dark:bg-blue-400  text-blue-600 hover:text-blue-800 dark:text-blue-800 dark:hover:text-blue-600 `}>
                        AT
                        <div
                            className={`absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white  border-2 border-white rounded-full -top-3 -right-4 dark:border-gray-800 ${
                                linhaP?.atributos?.length == 0 || linhaP?.atributos?.length == undefined ? 'bg-red-500' : 'bg-green-500'
                            }`}>
                            {linhaP?.atributos?.length || 0}
                        </div>
                    </button>
                    <span className="cursor-pointer ml-2 text-gray-500" onClick={() => setAberturaLinhaAtributos(!aberturaLinhaAtributos)}>
                        {' '}
                        {aberturaLinhaAtributos == false ? <ExpandMoreRoundedIcon style={{fontSize: '2rem'}} /> : <ExpandLessRoundedIcon style={{fontSize: '2rem'}} />}
                    </span>
                </td>
                <td className=" text-center w-20">
                    {/* Botão de acessorios */}
                    <button
                        disabled={isEmpty()}
                        title={t('acessorios')}
                        type="button"
                        onClick={() => {
                            if (editarProposta) {
                                setOpenAcessoriosModal(!openAcessoriosModal);
                            }
                        }}
                        className="relative inline-flex items-center font-bold p-1 text-xs  text-center cursor-pointer rounded-[5px] bg-blue-200  text-blue-600 dark:bg-blue-400 hover:text-blue-800 dark:text-blue-800 dark:hover:text-blue-600 ">
                        AC
                        <div
                            className={`absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white  border-2 border-white rounded-full -top-3 -right-4 dark:border-gray-800 ${
                                linhaP?.acessorios?.length == 0 || linhaP?.acessorios?.length == undefined ? 'bg-red-500' : 'bg-green-500'
                            }`}>
                            {linhaP?.acessorios?.length == null ? 0 : linhaP?.acessorios?.length}
                        </div>
                    </button>
                    <span className="cursor-pointer ml-2 text-gray-500 " onClick={() => setAberturaLinhaAcessorios(!aberturaLinhaAcessorios)}>
                        {' '}
                        {aberturaLinhaAcessorios == false ? <ExpandMoreRoundedIcon style={{fontSize: '2rem'}} /> : <ExpandLessRoundedIcon style={{fontSize: '2rem'}} />}
                    </span>
                </td>
                <td className="text-left w-20">
                    {/* Botão de extras */}
                    <button
                        disabled={isEmpty()}
                        title={t('acessoriosExtra')}
                        type="button"
                        onClick={() => {
                            if (editarProposta) {
                                setOpenAcessoriosExtraModal(!openAcessoriosExtraModal);
                            }
                        }}
                        className="relative inline-flex items-center p-1 text-xs font-bold text-center cursor-pointer rounded-[5px] bg-blue-200  text-blue-600 dark:bg-blue-400 hover:text-blue-800 dark:text-blue-800 dark:hover:text-blue-600 ">
                        EX
                        <div
                            className={`absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white border-2 border-white rounded-full -top-3 -right-4 dark:border-gray-800 ${
                                linhaP?.acessoriosExtra?.length == 0 || linhaP?.acessoriosExtra?.length == undefined ? 'bg-red-500' : 'bg-green-500'
                            }`}>
                            {linhaP?.acessoriosExtra?.length == null ? 0 : linhaP?.acessoriosExtra?.length}
                        </div>
                    </button>
                    <span className="cursor-pointer ml-2 text-gray-500 " onClick={() => setAberturaLinhaAcessoriosExtra(!aberturaLinhaAcessoriosExtra)}>
                        {' '}
                        {aberturaLinhaAcessoriosExtra == false ? <ExpandMoreRoundedIcon style={{fontSize: '2rem'}} /> : <ExpandLessRoundedIcon style={{fontSize: '2rem'}} />}
                    </span>
                </td>
                <th scope="row" className="w-72 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg>
                        </div>
                        <input
                            disabled={!editarProposta}
                            type="search"
                            id="default-search"
                            value={linhaP?.referencia == undefined ? '' : linhaP?.referencia}
                            className="block w-full p-2 pl-10 text-xs text-gray-900 dark:text-gray-200 border border-gray-300 dark:border-gray-600 rounded-[8px] bg-gray-50 dark:bg-gray-900 focus:ring-blue-500 focus:border-blue-500 "
                            onClick={() => {
                                if (editarProposta) {
                                    setOpenReferenciaModal(!openReferenciaModal);
                                }
                            }}
                            onChange={e => {
                                setValidacaoEquipamento(false);
                                if (editarProposta) {
                                    setOpenReferenciaModal(!openReferenciaModal);
                                }
                                // setSearchExtra(e.target.value);
                                // setFiltroRef(e.target.value);
                            }}
                        />
                    </div>
                    {linhaP.validacaoEquipamento ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                </th>

                <td className="px-6 py-4">{linhaP?.nome}</td>
                <td className="px-6 py-4">{linhaP?.stock}</td>
                <td className="px-6 py-4">{linhaP?.encFornc}</td>
                {!aluguer && (
                    <td className="px-6 py-4">
                        <input
                            disabled={!editarProposta}
                            type="number"
                            placeholder="0"
                            min={0}
                            value={linhaP.ecoValor || ''}
                            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                            onChange={e => {
                                // if (Number(e.target.value) < 0) linhaP.ecoValor = 0;
                                // else linhaP.ecoValor = Number(e.target.value);
                                // handleChildChange(linhaP);

                                const newValue = e.target.value;
                                const newValor = newValue !== '' ? Number(newValue) : 0;
                                const updatedLinhaP = {...linhaP, ecoValor: newValor};
                                handleChildChange(updatedLinhaP);
                            }}
                        />
                    </td>
                )}
                {/* {!aluguer && (
                    <td className="px-6 py-4">
                        <div className="flex flex-row items-center">
                           
                            <input
                                disabled={!editarProposta}
                                type="number"
                                placeholder="0"
                                min={0}
                                value={linhaP?.iva || ''}
                                className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                                onChange={e => {
                                  

                                    const newValue = e.target.value;
                                    const newValor = newValue !== '' ? Number(newValue) : 0;
                                    const updatedLinhaP = {...linhaP, iva: newValor};
                                    handleChildChange(updatedLinhaP);
                                }}
                            />
                            {validacaoIVA ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                        </div>
                    </td>
                )} */}
                <td className="px-6 py-4">
                    <input
                        disabled={!editarProposta}
                        type="number"
                        placeholder="0"
                        value={linhaP.quantidade || ''}
                        className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                        onChange={e => {
                            const newValue = e.target.value;
                            const newQuantidade = newValue !== '' ? Math.max(0, Number(newValue)) : 0;
                            const updatedLinhaP = {...linhaP, quantidade: newQuantidade, validacaoQuantidade: false};
                            handleChildChange(updatedLinhaP);
                        }}
                    />

                    {linhaP.validacaoQuantidade ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                </td>
                {!aluguer && (
                    <td className="px-6 py-4">
                        <input
                            disabled={!editarProposta}
                            type="number"
                            min={0}
                            placeholder="0"
                            value={linhaP?.preco || ''}
                            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                            onChange={e => {
                                const newValue = e.target.value;
                                const newPreco = newValue !== '' ? Math.max(0, Number(newValue)) : 0;
                                const updatedLinhaP = {...linhaP, preco: newPreco};
                                handleChildChange(updatedLinhaP);
                            }}
                        />
                    </td>
                )}
                {!aluguer && (
                    <td className="px-6 py-4">
                        <input
                            max={100}
                            min={0}
                            disabled={!editarProposta}
                            placeholder="0"
                            type="number"
                            value={linhaP?.desconto || ''}
                            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                            onChange={e => {
                                const newValue = e.target.value;
                                let newDesconto;
                                if (newValue === '') {
                                    newDesconto = 0;
                                } else {
                                    const parsedValue = Number(newValue);
                                    if (parsedValue > 100) {
                                        newDesconto = 100;
                                    } else if (parsedValue < 0) {
                                        newDesconto = 0;
                                    } else {
                                        newDesconto = parsedValue;
                                    }
                                }
                                const updatedLinhaP = {...linhaP, desconto: newDesconto};
                                handleChildChange(updatedLinhaP);
                            }}
                        />
                    </td>
                )}
                {!aluguer && (
                    <td className="px-6 py-4">
                        <input
                            type="text"
                            value={calculoTotalLinha().toFixed(2)}
                            className="block w-full font-bold text-right text-sm mt-2 p-1 pl-2 dark:text-gray-200 focus:ring-indigo-500 focus:border-indigo-500 bg-gray-200 border-gray-100 rounded-[5px] shadow-sm dark:bg-gray-700 dark:border-gray-700"
                            disabled
                        />
                    </td>
                )}
                {!aluguer && (
                    <td className="px-6 py-4">
                        <input
                            type="text"
                            value={calculoTotalLinhaCExtra().toFixed(2)}
                            className="block w-full font-bold text-right text-sm mt-2 p-1 pl-2 dark:text-gray-200 focus:ring-indigo-500 focus:border-indigo-500 bg-gray-200 border-gray-100 rounded-[5px] shadow-sm dark:bg-gray-700 dark:border-gray-700"
                            disabled
                        />
                    </td>
                )}

                <td className="px-6 py-4">
                    <>
                        {Number(linha) != totalLinhas && (
                            <button
                                disabled={!editarProposta}
                                type="button"
                                className={`inline-flex text-xs justify-center rounded-full text-white px-2 py-1 font-semibold  shadow-sm  sm:ml-3 sm:w-auto ${'bg-red-600 hover:bg-red-700'}`}
                                onClick={() => eliminarLinha(linhaP.idLinha)}>
                                <DeleteForeverRoundedIcon style={{width: '15px'}} />
                            </button>
                        )}
                        {linhaP.referencia !== 0 && Number(linha) == totalLinhas && (
                            <button
                                disabled={!editarProposta}
                                type="button"
                                className={`inline-flex text-xs justify-center rounded-full text-white px-2 py-1 font-semibold  shadow-sm  sm:ml-3 sm:w-auto ${'bg-blue-600 hover:bg-blue-700'}`}>
                                <AddRoundedIcon style={{width: '15px'}} onClick={adicionarNovaLinha} />
                            </button>
                        )}
                    </>
                </td>
            </tr>

            {aberturaLinhaAtributos && (
                <>
                    {linhaP?.atributos?.map((atributo, index) => {
                        return (
                            <Atributos
                                atributo={atributo}
                                handleChildChange1={item => {
                                    var linha = Object.assign({}, linhaP);
                                    linha.atributos[index] = item;
                                    handleChildChange(linha);
                                }}
                                aluguer={aluguer}
                            />
                        );
                    })}
                </>
            )}

            {aberturaLinhaAcessorios && (
                <>
                    {linhaP?.acessorios?.map((acessorio, index) => {
                        return (
                            <Acessorios
                                acessorio={acessorio}
                                linhaP={linhaP}
                                editarProposta={editarProposta}
                                handleChildChange2={item => {
                                    var linha = Object.assign({}, linhaP);
                                    linha.acessorios[index] = item;
                                    handleChildChange(linha);
                                }}
                                aluguer={aluguer}
                            />
                        );
                    })}
                </>
            )}

            {aberturaLinhaAcessoriosExtra && (
                <>
                    {linhaP?.acessoriosExtra?.map((acessoriosExtra, index) => {
                        return (
                            <AcessoriosExtra
                                linhaP={linhaP}
                                editarProposta={editarProposta}
                                acessoriosExtra={acessoriosExtra}
                                handleChildChange1={item => {
                                    var linha = Object.assign({}, linhaP);
                                    linha.acessoriosExtra[index] = item;
                                    handleChildChange(linha);
                                }}
                                ivas={ivas}
                                aluguer={aluguer}
                            />
                        );
                    })}
                </>
            )}

            {openAtributosModal && (
                <AtributosModal
                    back={() => {
                        setOpenAtributosModal(!openAtributosModal);
                    }}
                    setAtributos={atributos => {
                        var linha = Object.assign({}, linhaP);
                        linha.atributos = atributos;
                        handleChildChange(linha);
                    }}
                    artigo={linhaP.referencia}
                    atributos={linhaP.atributos}
                />
            )}

            {openAcessoriosModal && (
                <AcessoriosModal
                    back={() => {
                        setOpenAcessoriosModal(!openAcessoriosModal);
                    }}
                    setAcessorios={acessorios => {
                        var linha = Object.assign({}, linhaP);
                        linha.acessorios = acessorios;
                        handleChildChange(linha);
                    }}
                    acessorios={linhaP.acessorios}
                    artigo={linhaP.referencia}
                />
            )}

            {openAcessoriosExtraModal && (
                <div className="flex items-center justify-center min-h-screen">
                    <AcessoriosExtraModal
                        Getartigos={e => Getartigos(e)}
                        setSearchExtra={setSearchExtra}
                        searchExtra={searchExtra}
                        artigosExtras={artigosExtras}
                        setArtigosExtras={setArtigosExtras}
                        artigos={artigos}
                        back={() => {
                            setOpenAcessoriosExtraModal(!openAcessoriosExtraModal);
                        }}
                        setAcessoriosExtra={acessoriosExtra => {
                            var linha = Object.assign({}, linhaP);
                            linha.acessoriosExtra = acessoriosExtra;
                            handleChildChange(linha);
                        }}
                        acessoriosExtra={linhaP?.acessoriosExtra}
                        aluguer={aluguer}
                    />
                </div>
            )}
            {openReferenciaModal && (
                <ReferenciaModal
                    setSearchReferencia={setSearchReferencia}
                    searchReferencia={searchReferencia}
                    referenciaArtigos={referenciaArtigos}
                    setReferenciaArtigos={setReferenciaArtigos}
                    back={() => {
                        setOpenReferenciaModal(!openReferenciaModal);
                    }}
                    setMaquina={maquina => {
                        var linha = Object.assign({}, linhaP);
                        if (linha.referencia != maquina.value) {
                            linha.acessoriosExtra = [];
                            linha.acessorios = [];
                            linha.atributos = [];
                        }

                        if (maquina.value) {
                            linha.quantidade = 1;
                        } else {
                            linha.quantidade = 0;
                        }

                        linha.referencia = maquina.value;
                        linha.nome = maquina.label;

                        handleChildChange(linha);
                    }}
                    maquinas={linhaP.referencia ? [{...linhaP, value: linhaP.referencia, label: linhaP.nome}] : []}
                />
            )}
        </>
    );
}

export default Linha;
